import type { VAxios } from '../../define/axios/Axios';

interface SrJob {
  denoise?: boolean;
  imgUrl: string;
  uploadAddress: {
    accessKeyId?: string;
    accessKeySecret?: string;
    bucketName?: string;
    endpoint?: string;
    folder?: string;
    securityToken?: string;
  };
  upscale?: number;
}

/**
 * 超分相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 通过上传图片解析骨骼图节点信息
  superResolution: (params: SrJob) => defHttp.post({ url: `/editor/sr`, params }),
});
